import { openBlock as a, createElementBlock as t, createStaticVNode as e } from "vue";
const h = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, c = /* @__PURE__ */ e('<g clip-path="url(#a)"><path d="M8.75 1a.75.75 0 0 0-1.5 0v6.25H1a.75.75 0 0 0 0 1.5h6.25V15a.75.75 0 0 0 1.5 0V8.75H15a.75.75 0 0 0 0-1.5H8.75V1Z"></path><path d="M12 5.75a.75.75 0 0 1-.75-.75v-.25H11a.75.75 0 0 1 0-1.5h.25V3a.75.75 0 0 1 1.5 0v.25H13a.75.75 0 0 1 0 1.5h-.25V5a.75.75 0 0 1-.75.75ZM5.75 4a.75.75 0 0 1-.75.75H3a.75.75 0 0 1 0-1.5h2a.75.75 0 0 1 .75.75ZM13 11.75a.75.75 0 0 0 0-1.5h-2a.75.75 0 0 0 0 1.5h2Zm.75 1.25a.75.75 0 0 1-.75.75h-2a.75.75 0 0 1 0-1.5h2a.75.75 0 0 1 .75.75Zm-8.69-1 .47.47a.75.75 0 1 1-1.06 1.06L4 13.06l-.47.47a.75.75 0 0 1-1.06-1.06l.47-.47-.47-.47a.75.75 0 1 1 1.06-1.06l.47.47.47-.47a.75.75 0 0 1 1.06 1.06l-.47.47Z"></path></g><defs><clipPath id="a"><path d="M0 0h16v16H0z"></path></clipPath></defs>', 2), o = [
  c
];
function l(p, d) {
  return a(), t("svg", h, [...o]);
}
const s = { render: l };
export {
  s as default,
  l as render
};
